import React, { useContext } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { Button } from "../../Theme/Hyper";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { ControlContext } from "../../contexts/ControlContext";
import HyperLogo from "../../Images/HyperLogo.png";
import { useParams } from "react-router";

const TeamNamePanel = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 7vh;
  font-size: 16px;
`;
const Team = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  display: flex;
  width: 40%;
  align-items: center;
  height: 54px;
  font-size: 14px;
`;
const Middle = styled.div`
  display: flex;
  width: 20%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -10px;
`;
const TeamName = styled.div`
  padding-left: ${(props) => (props.home ? "0.5em" : "")};
  margin-left: ${(props) => (props.home ? "auto" : "")};
  display: flex;
  font-size: 1.5em;

  width: 100%;
`;
const Score = styled.div`
  display: flex;
  font-size: 3em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  align-items: center;
  justify-content: center;

  border-radius: 2px;
`;

const Logo = styled.img`
  height: 40px;
  margin: 10px;
`;
export default function TeamNamesMobile({
  setGoalScored,
  game,
  setSelectedPlayer,
  isFruit = false,
}) {
  const { commID } = useParams();
    const history = useHistory();
    const location = useLocation();
  const { setView, selectedTeam, setGoal } = useContext(UIContext);
  const { updateGame } = useContext(APIContext);
  const { clear } = useContext(ControlContext);
  const [ GameSave ] = useLocalStorage("hyper-combat-fightcard");
   const { gamesByDate, setSelectedGameID, setSelectedGame, nextGame, setNextGame, lastGame, setLastGame } = useContext(DataContext);

  if (gamesByDate && gamesByDate.length > 0) {
        let gamepos = gamesByDate?.map(function(games) {return games._id }).indexOf(game._id);
        let nextGameupdate = gamesByDate[(parseInt(gamepos)+1)] || "";
        let lastGameupdate = gamesByDate[(gamepos-1)] || "";
        setNextGame(nextGameupdate);
        setLastGame(lastGameupdate);
      } else {
        let cachedresult = GameSave.cachedGames
        let gamepos = cachedresult?.map(function(games) {return games._id }).indexOf(game._id);
        let nextGameupdate = cachedresult[(parseInt(gamepos)+1)] || "";
        let lastGameupdate = cachedresult[(gamepos-1)] || "";
        setNextGame(nextGameupdate);
        setLastGame(lastGameupdate);
  }



  let homeBGColour = game.home_fighter?.shorts_colour || "";
  let awayBGColour = game.away_fighter?.shorts_colour || "";

  let try_points = game?.competition?.competition_type === "union" ? 5 : 4;
  let conversion_points =
    game?.competition?.competition_type === "union" ? 2 : 2;
  let penalty_kick_points =
    game?.competition?.competition_type === "union" ? 3 : 2;
  let penalty_try_points =
    game?.competition?.competition_type === "union" ? 7 : 4;
  let drop_goal_points =
    game?.competition?.competition_type === "union" ? 3 : 1;
  return (
    <div className="flex flex-col w-full bg-section px-5 py-2 gap-1 font-manrope">
    <div className="flex flex-row bg-surface rounded-xl items-center justify-items-center w-full">
      <div className="flex items-center w-[40%] justify-end my-5"
        style={{
          borderBottom:
            "3px solid " + (homeBGColour ? homeBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.home_fighter._id
              ? "1"
              : ".2",
        }}
      >
        <div className="flex text-lg  text-on-surface font-bold border-b-2 border-red-500 py-1">
          {game?.home_fighter?.first_name} {game?.home_fighter?.last_name}
        </div>
      </div>
      <Middle>Vs</Middle>
      <div className="flex items-center w-[40%] justify-start"
        style={{
          borderBottom:
            "3px solid " + (awayBGColour ? awayBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.away_fighter._id
              ? "1"
              : ".2",
        }}
      >
        <div className="flex text-lg  text-on-surface font-bold border-b-2 border-blue-500 py-1">
          {game.away_fighter?.first_name} {game.away_fighter?.last_name}
        </div>
      </div>
    </div>
    <div className="flex flex-row bg-surface-container-low rounded-xl items-center justify-center w-full py-4">
    <div className="flex items-center w-[40%] justify-end">
    <button className="bg-red-500 hover:border-[#76ffb0] hover:border-1 text-black px-5 py-2 rounded mr-5 text-sm"
    onClick={() => {setSelectedGameID(lastGame._id);
                setSelectedGame(lastGame);
                let path = location.pathname.split('/')[0];


                history.push({
                  pathname:
                    path.replace("/", "") +
                    "/comms/" +
                    lastGame._id + "/" + commID,
                });
              }}>
    { lastGame !== "" ? `← ${lastGame?.home_fighter?.last_name} vs ${lastGame?.away_fighter?.last_name}` : "No Previous Game" }
    </button>
    </div>
    <div className="w-[10%]"></div>
    <div className="flex items-center w-[40%] justify-start">
    <button className="bg-primary hover:border-[#76ffb0] hover:border-1 text-black px-5 py-2 rounded ml-5 text-sm"
    onClick={() => {setSelectedGameID(nextGame._id);
                setSelectedGame(nextGame);
                let path = location.pathname.split('/')[0];


                history.push({
                  pathname:
                    path.replace("/", "") +
                    "/comms/" +
                    nextGame._id + "/" + commID,
                });
              }}>
    { nextGame !== "" ? `${nextGame?.home_fighter?.last_name} vs ${nextGame?.away_fighter?.last_name} →` : "No Further Games" }
    </button>
    </div>
    </div>
    </div>
  );
}
